<template>

    <div @click="rootDivClickHandle">
        <el-row>
            <div class="left-justifying"><h3>机房监察配置</h3></div>

            <div class="right-justifying">
                <el-button v-if="addBtnVisible && canOper" @click="btnNewClickHandle()" type="info" plain size="small">
                    <i class="fa fa-plus-circle"></i> 新建
                </el-button>
                <el-button v-if="modiBtnVisible && canOper" @click="btnModiClickHandle()" type="info" plain size="small">
                    <i class="fa fa-pencil"></i> 修改
                </el-button>
                <el-button v-if="cancelVisible && canOper" @click="btnCancelClickHandle()" type="info" plain size="small">
                    <i class="fa fa-pencil"></i> 取消
                </el-button>
                <el-button v-if="saveBtnVisible && canOper" @click="btnSaveClickHandle()" type="info" plain size="small">
                    <i class="fa fa-save"></i> 保存
                </el-button>
                <el-button v-if="delBtnVisible && canOper" @click="btnDelClickHandle()" type="info" plain size="small">
                    <i class="fa fa-times"></i> 删除
                </el-button>
                <!-- 仅活动状态的配置版本才能进行修订 -->
                <el-button v-if="reviseBtnVisible && (assessmentVersionDetail.status == 'ACTIVE' || assessmentVersionDetail.status == 'INACTIVE') && canOper && this.$refs.avdRef.disableFlag == true"
                           @click="btnReviseClickHandle($event)" type="info" plain size="small">
                    <i class="fa fa-pencil"></i> 修订
                </el-button>
            </div>

        </el-row>

        <div class="panel">
            <div class="panel-body">

                <el-tabs v-model="activeTab" @tab-click="handle_tab_click">
                    <el-tab-pane label="列表" name="table_tab">
                        <assessment-version-table ref="avtRef"
                                                  @showDetailTab="showDetailTab"></assessment-version-table>
                    </el-tab-pane>
                    <el-tab-pane label="评分配置" name="detail_tab">
                        <assessment-version-detail ref="avdRef"></assessment-version-detail>
                    </el-tab-pane>
                </el-tabs>
            </div>

        </div>

    </div>

</template>

<script>

    import assessmentVersionTable from "./assessmentVersionTable";
    import assessmentVersionDetail from "./assessmentVersionDetail";
    import assessmentVersionStatus from "../mixins/assessmentVersionStatus";
    import {createNamespacedHelpers} from "vuex";
    import AssessmentServer from "../../../api/assessment";
    import {add} from "../utils/math";
    import {formatDate} from 'element-ui/lib/utils/date-util'

    import {ASSESSMENT_PERMISSION} from '../assessment_common'

    const assessmentVersionNSHelper = createNamespacedHelpers("assessment/assessmentVersion");

    const assessmentConfigNSHelper = createNamespacedHelpers("assessment/assessmentConf");

    export default {
        name: "assessmentVersion",

        mixins: [assessmentVersionStatus],

        components: {
            assessmentVersionTable,
            assessmentVersionDetail,

        },

        data() {
            return {
                activeTab: 'table_tab',

                dropDownVisible: true,
                addBtnVisible: true,
                modiBtnVisible: false,
                cancelVisible: false,
                reviseBtnVisible: false,
                saveBtnVisible: false,
                delBtnVisible: false,

                canOper: true,
            }
        },

        methods: {

            ...assessmentVersionNSHelper.mapActions(['getAssessmentVersionDetail']),
            ...assessmentVersionNSHelper.mapMutations(['setAssessmentVersionDetail']),
            ...assessmentConfigNSHelper.mapMutations(['setErrorIds']),

            handle_tab_click(tab, event) {
                this.activeTab = tab.name;
            },

            showDetailTab() {
                this.$refs.avdRef.disableFlag = true;
                this.activeTab = "detail_tab";
            },

            btnNewClickHandle() {

                AssessmentServer.assessmentVersion.list({}).then((responseBody) => {
                    let versionArr = responseBody.data.data.sort((a, b) => {
                        return a.id < b.id ? 1 : -1
                    });
                    let currentVersion = 0;
                    if (versionArr == null || versionArr.length == 0) {
                        currentVersion = 1;
                    } else {
                        currentVersion = versionArr[0].version;
                        currentVersion = add(currentVersion, 0.1);
                    }
                    let params = {
                        id: null,
                        version: currentVersion,
                        status: 'DRAFT',
                        changeby: localStorage.getItem("realname"),
                        changedate: formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                    }
                    this.setAssessmentVersionDetail(params);

                    this.$refs.avdRef.disableFlag = true;
                    this.activeTab = "detail_tab";
                });

            },

            btnModiClickHandle() {
                this.$refs.avdRef.disableFlag = false;
                this.activeTab = "detail_tab";

                this.modiBtnVisible = false;
                this.cancelVisible = true;
            },

            btnCancelClickHandle() {
                this.$refs.avdRef.disableFlag = true;
                this.modiBtnVisible = true;
                this.cancelVisible = false;
                this.getAssessmentVersionDetail(this.$refs.avdRef.assessmentVersionDetail.id);
            },

            btnSaveClickHandle() {
                if (this.$refs.avdRef.assessmentVersionDetail.id == null) {
                    AssessmentServer.assessmentVersion.add(this.$refs.avdRef.assessmentVersionDetail).then(res => {
                        if (res.data.code == 200) {
                            this.setAssessmentVersionDetail(res.data.data);
                            this.$message.success("新建机房监察配置成功");
                            this.$refs.avtRef.queryTable();
                            this.$refs.avdRef.disableFlag = true;

                            this.modiBtnVisible = true;
                            this.delBtnVisible = true;
                        } else {
                            this.$message.error("新建机房监察配置失败");
                        }
                    });
                } else {
                    AssessmentServer.assessmentVersion.list({}).then((responseBody) => {
                        let assessmentVersions = responseBody.data.data.filter(e => e.status == 'ACTIVE');
                        if (assessmentVersions != null && assessmentVersions.length > 0 && this.$refs.avdRef.changeStatusWarring == false) {
                            this.$confirm('所有版本中只允许其中一个版本为活动状态，执行此操作，已有活动版本将自动转为不活动，是否继续？', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.saveOper();
                            })
                        } else {
                            this.saveOper();
                        }
                    });
                }
            },

            saveOper() {
                this.$refs.avdRef.assessmentVersionDetail.changeby = localStorage.getItem('realname');
                AssessmentServer.assessmentVersion.update(this.$refs.avdRef.assessmentVersionDetail.id, this.$refs.avdRef.assessmentVersionDetail).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success("更新机房监察配置成功");
                        this.$refs.avtRef.queryTable();
                        this.$refs.avdRef.disableFlag = true;
                        this.modiBtnVisible = true;
                        this.cancelVisible = false;
                        this.setErrorIds([]);
                        this.$refs.avdRef.assessmentVersionDetail.changedate = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss');
                    } else {
                        this.$message.error("更新机房监察配置失败，原因可能：同层级分项评分配置权重不满100");
                        this.$refs.avdRef.assessmentVersionDetail.status = 'DRAFT';
                        this.setErrorIds(res.data.message.split(','));
                    }
                });
            },

            btnDelClickHandle() {
                if (this.$refs.avdRef.assessmentVersionDetail.status != 'DRAFT') {
                    this.$message.error("非草稿状态禁止删除");
                } else {
                    this.$confirm('删除此考评项, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        AssessmentServer.assessmentVersion.delete(this.$refs.avdRef.assessmentVersionDetail.id).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success("删除机房监察成功");
                                this.$refs.avtRef.queryTable();
                                this.activeTab = 'table_tab';
                            } else {
                                this.$message.error("删除机房监察配置失败:" + res.data.message);
                            }
                        });
                    }).catch(() => {
                        console.log('已取消删除');
                    });
                }
            },

            btnReviseClickHandle(e) {
                AssessmentServer.assessmentVersion.revise(this.assessmentVersionDetail).then(res => {
                    this.$message.success('新监察配置已生成，请修订');
                    this.$refs.avtRef.queryTable();
                    this.getAssessmentVersionDetail(res.data);
                });
            },

            //点击任意处，都会关闭tabletree右键弹出的DIV框
            rootDivClickHandle() {
                if (this.$refs.avdRef.$refs.actRef != null) {
                    this.$refs.avdRef.$refs.actRef.$refs.menuDivRef.style.display = 'none';
                }
            },

        },

        computed: {
            ...assessmentVersionNSHelper.mapGetters(['assessmentVersionDetail']),
        },

        watch: {
            activeTab: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    if (newVal == 'table_tab') {
                        this.addBtnVisible = true;
                        this.modiBtnVisible = false;
                        this.cancelVisible = false;
                        this.reviseBtnVisible = false;
                        this.saveBtnVisible = false;
                        this.delBtnVisible = false;
                    } else {
                        this.addBtnVisible = false;
                        this.cancelVisible = false;
                        this.reviseBtnVisible = true;
                        this.saveBtnVisible = true;

                        if (this.assessmentVersionDetail.id != null) {
                            this.modiBtnVisible = true;
                            this.delBtnVisible = true;
                        } else {
                            this.modiBtnVisible = false;
                            this.delBtnVisible = false;
                        }

                        //默认选中子组件中的分项配置评分TAB
                        this.$refs.avdRef.activeTab = 'fxpf_tab';
                    }

                    this.canOper = this.hasPermission(ASSESSMENT_PERMISSION);
                }
            },

            assessmentVersionDetail: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    if (newVal != null && newVal.id != null) {
                        this.modiBtnVisible = true;
                        this.delBtnVisible = true;
                    } else {
                        this.modiBtnVisible = false;
                        this.delBtnVisible = false;
                    }
                }
            },

        },

    }
</script>

<style scoped>

</style>